<template>
    <div class="help">
        <p class="tips">激活学生证需要完成以下三步：</p>
        <div class="step">
            <p>Step1：学生证缴费</p>
            <div class="btn" @click="gopage(1)">学生证缴费教程</div>
        </div>
        <div class="step">
            <p>Step2：绑定学生证</p>
            <div class="btn" @click="gopage(2)">学生证绑定教程</div>
        </div>
        <div class="step">
            <p>Step3：实名认证学生证里的手机卡</p>
            <!-- <p>移动手机卡</p>
            <div class="content">
                <div class = "img">
                    <img src="../../assets/studentCard_2.png" alt="" />
                </div>
                <div class = "remark">
                    <p>点击这里查看实名教程</p>
                    <div class="img-btn" @click="gopage(3)">移动实名认证教程</div>
                </div>                
            </div> -->

            <p style="margin-top:0.5rem">联通手机卡</p>
            <div class="content">
                <div class = "img">
                    <img src="../../assets/liantongCard_2.png" alt="" />
                </div>
                <div class = "remark">
                    <p>点击这里查看实名教程</p>
                    <div class="img-btn" @click="gopage(4)">联通实名认证教程</div>
                </div>
                 
            </div>
            <!-- <div class="btn" @click="gopage(3)">查看操作演示</div> -->
        </div>
        <h3>学生证激活更多注意事项</h3>
        <p class="attention">1. 学生证缴费后并没有立即激活，需要对学生证的手机卡进行实名认证之后才能激活</p>
        <p class="attention">2. 激活通常需要等待5分钟左右，长时间还没有联网，请重启设备即可</p>
        <p class="attention">3. 请确保要激活的学生证已开机</p>
        <p class="attention">4. 有多个孩子时，请确保缴费和实名认证的学生证是要激活的学生证</p>
        <p class="attention">5. 注意学生证卡不能更换，更换其他物联网卡会锁机无法使用</p>
        <p class="attention">6. 打电话给学生证时，必须确保已经将家长号码设置为学生证的亲情号码</p>
        <p class="attention">7. 更多问题请联系人工客服：<span>0512-66666628</span></p>
    </div>
</template>
 
<script>
export default {
    methods: {
        gopage(type) {
            switch(type) {
                case 1:
                    this.$router.push({
                        path: '/studentJiaoFei'
                    })
                    break;
                case 2:
                    this.$router.push({
                        path: '/studentBangding'
                    })
                    break;
                case 3:
                    this.$router.push({
                        path: '#'
                    })
                    break;
                case 4:
                    this.$router.push({
                        path: '/liantongshiming'
                    })
                    break;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.help {
    background: #F5F5F5;
    .tips {
        padding: .22rem .30rem;
        font-size: .3rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
    }
    .step {
        width: 100%;
        padding: .32rem .3rem;
        margin-bottom: .2rem;
        background: #fff;
        p {
            font-size: .32rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #222222;
            margin-bottom: .24rem;
            span {
                font-size: .3rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
            }
        }
        .btn {
            // width: 6.9rem;
            height: 1rem;
            background: #2AD0B5;
            border-radius: .2rem;
            line-height: 1rem;
            text-align: center;
            font-size: .34rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
        }
        .content{
            .img{
                float: left;
                display: block;
                width: 30%;
                // position:absolute;
                // border: 1px dashed #999999;
                img{
                    width: 100%;
                }
            }
            .remark{
                width: 70%;
                float: right;
               .img-btn{
                    width: 100%;
                    height: 1rem;
                    background: #2AD0B5;
                    border-radius: .2rem;
                    line-height: 1rem;
                    text-align: center;
                    font-size: .34rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                    float: right;
                }
            }
            
        }
        .content::after{
            content: "";
                clear: both;
                display:block
        }
        
    }
    h3 {
        font-size: .32rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222220;
        padding: .26rem .3rem;
    }
    .attention {
        font-size: .3rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        padding: .12rem .3rem;
        span {
            color: #26A892;
        }
    }
}
</style>
